module.exports = __webpack_public_path__ + "static/media/eliminarCuenta.2dbc1f49.svg";